import PropTypes from 'prop-types';
import { withLabels } from '../../../utils/LabelsContext';
import Alert from '../../ui/Alert/Alert';
import { AvailabilityDesktopStyles } from './AvailabilityDesktop/style';

const AvailabilityDesktopDownloadable = ({ labels }) => {
  return (
    <>
      <div className="availability-item">
        <div className="content downloadAvailable" id="testId-Availability-Desktop-ModalOpen-downloadAvailable">
          <Alert content={() => labels.AVAILABILITY_DOWNLOADABLE} toggleState={{ visible: true }} type="info" />
        </div>
      </div>
      <style jsx>{AvailabilityDesktopStyles}</style>
    </>
  );
};

AvailabilityDesktopDownloadable.propTypes = {
  labels: PropTypes.object,
};

AvailabilityDesktopDownloadable.defaultProps = {
  labels: {},
};

export { AvailabilityDesktopDownloadable };
export default withLabels(AvailabilityDesktopDownloadable);
